(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewel-home-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rwh').forEach((root) => {
    if (root.dataset.motionReady) return;
    root.dataset.motionReady = 'true';
    root.classList.add('rwh-motion-ready');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = [...root.querySelectorAll('.rwh-head,.rwh-missions__grid>a,.rwh-levels__scene,.rwh-reviews__grid,.rwh-reviews__empty,.rwh-editorial__copy,.rwh-editorial__main,.rwh-editorial__side,.rwh-journal__grid>a')];
    revealItems.forEach((item) => item.classList.add('rwh-reveal'));
    const routine = root.querySelector('[data-rwh-routine]');
    const scene = root.querySelector('.rwh-levels__scene');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-in'));
      if (routine) routine.classList.add('is-active');
      if (scene) scene.classList.add('is-in');
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      revealItems.forEach((item) => observer.observe(item));
      if (routine) {
        const routineObserver = new IntersectionObserver((entries) => {
          if (entries[0] && entries[0].isIntersecting) {
            routine.classList.add('is-active');
            routineObserver.disconnect();
          }
        }, { threshold: .35 });
        routineObserver.observe(routine);
      }
    }
    const track = root.querySelector('[data-mission-track]');
    root.querySelectorAll('[data-mission-prev],[data-mission-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!track) return;
        const direction = button.hasAttribute('data-mission-prev') ? -1 : 1;
        track.scrollBy({ left: direction * track.clientWidth * .78, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
